import * as React from 'react';
const BodyContext = React.createContext(null);
export default BodyContext;
